import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { PosterListComponent } from 'src/app/shared/components/poster-list/poster-list.component';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    imports: [CommonModule, RouterModule, PosterListComponent, MatRippleModule]
})
export class NotFoundComponent {
  NavigationService = NavigationService;

  assetsPath = 'assets/images/not-found/';
}
